import React, { useState } from "react";

import "../../pages/login/Style.css";


import { useNavigate } from "react-router-dom";
import api from '../../services/api';
import getBrowserFingerprint from 'get-browser-fingerprint';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import 'react-toastify/dist/ReactToastify.min.css';
import { getImage } from "../../services/getAssets";

export default function () {
  const [cpf, setCpf] = useState('');
  const [password, setPassword] = useState('');

  const navigate = useNavigate();
  const fingerprint = getBrowserFingerprint();

  const [device, setDevice] = useState(false);

  async function requestLogin() {
    if (cpf == '' || password == '') {
      toast.error('Preencha os campos para fazer o login!')
      setPassword('')
      return;
    }

    await api.post('/login/auth', {
      'username': cpf,
      'password': password,
      'mac': fingerprint
    })
      .then(result => {
        const data = result.data.data
        
        localStorage.setItem('name', data.name)
        localStorage.setItem('taxNumber', data.taxNumber)
        localStorage.setItem('identifier', password)
        localStorage.setItem('deviceId', fingerprint)
        localStorage.setItem('personId', data.account[0].personId)
        localStorage.setItem('accountId', data.account[0].id)
        localStorage.setItem('bank', data.account[0].bank)
        localStorage.setItem('bankAccount', data.account[0].bankAccount)
        localStorage.setItem('bankAccountDigit', data.account[0].bankAccountDigit)
        localStorage.setItem('bankBranch', data.account[0].bankBranch)
        localStorage.setItem('login', result.data.login)

        navigate('/pagina-principal')
      })
      .catch(err => {
        setDevice(true)
        toast.error(err.response.data.message)
      })
  }

  return (
    <div className="pagina-login">

      <div className="container">
        <div className="logo row">
          <div className="col-xl-7">
            <img src={getImage('logo.png')} alt="" />
          </div>

          <div className="cadastro col-xl-5">
            <div className="acesse-sua-conta">
              <h1>Acesse sua conta agora mesmo!</h1>
            </div>

            <div className="area-login">
              <div>
                <p>CPF/CNPJ</p>
                <input
                  type="text"
                  placeholder="Digite seu CPF ou CNPJ"
                  value={cpf}
                  onChange={e => { setCpf(e.target.value) }}
                />
              </div>

              <div className="senha">
                <p>Senha</p>
                <input
                  type="password"
                  placeholder="Digite sua Senha"
                  value={password}
                  onChange={e => { setPassword(e.target.value) }}
                />
              </div>

              <div className="logar">
                {/* <Link to={"pagina-principal"}> */}
                <button onClick={e => requestLogin()}>Avançar</button>
                {/* </Link> */}

              </div>
              <div style={device ? { 'display': 'block' } : { 'display': 'none' }} className="device" id="device">
                <p>Solicite acesso ao suporte informando o ID abaixo:</p> 
                
                <input type="text" placeholder={fingerprint} disabled="disabled"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />

    </div>
  );
}
